<template>
  <v-menu
    v-model="active"
    :close-on-content-click="false"
    location="bottom"
  >
    <template v-slot:activator="{ props }">
      <div v-bind="props" class="ios-click-barrier">
        <v-text-field
          class="_v-digital-time-picker pointer-events-none"
          readonly
          :model-value="modelValue"
          v-bind="$attrs"
          tabindex="-1"
        />
      </div>
    </template>
    
    <v-card class="d-flex align-center pa-2" style="width:300px">
      <v-select
        append-icon=""
        class="_v-digital-time-picker__select pt-0 mt-0 align-center"
        hide-details
        :items="hourOptions"
        variant="outlined"
        density="compact"
        :model-value="hourValue"
        autocomplete="new-password"
        name="dummy-hour"
        @update:modelValue="onChangeValue($event, 'hour')"
      />
      <span class="_v-digital-time-picker__comma mx-1 font-weight-bold">
        :
      </span>
      <v-select
        append-icon=""
        class="_v-digital-time-picker__select pt-0 mt-0 align-center"
        hide-details
        :items="minutesOptions"
        variant="outlined"
        density="compact"
        :model-value="minuteValue"
        autocomplete="new-password"
        name="dummy-minute"
        @update:modelValue="onChangeValue($event, 'minute')"
      />
    </v-card>
  </v-menu>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

interface DataType {
  defaultZeroValue: string;
  hours: string[];
  minutes: string[];
  active: boolean;
}

enum OnChangeValueType {
  Hour = 'hour',
  Minute = 'minute',
}

export default defineComponent({
  name: 'TimePicker',

  data: (): DataType => ({
    defaultZeroValue: '00',
    hours: [],
    minutes: [],
    active: false,
  }),

  props: {
    modelValue: {
      type: String,
      default: '',
    },
  },

  computed: {
    splitValue(): string[] {
      return this.modelValue.split(':');
    },
    hourValue(): string {
      return this.splitValue[0] || this.defaultZeroValue;
    },
    minuteValue(): string {
      return this.splitValue[1] || this.defaultZeroValue;
    },
    hourOptions(): string[] {
      const length = 24;
      return Array.from({ length }, (value, index) => index.toString().padStart(2, '0'));
    },
    minutesOptions(): string[] {
      return ['00', '10', '20', '30', '40', '50'];
    },
  },

  methods: {
    valueTemplate(hour: string, minute: string): string {
      return `${hour}:${minute}`;
    },
    onChangeValue(value: string, type: string): void {
      if (type === OnChangeValueType.Hour) {
        this.$emit('update:modelValue', this.valueTemplate(value, this.minuteValue));
      } else if (type === OnChangeValueType.Minute) {
        this.$emit('update:modelValue', this.valueTemplate(this.hourValue, value));
        this.active = false;
      }
    },
  },
});
</script>

<style lang="scss" scoped>
$font-size: 20px !default;

.ios-click-barrier {
  cursor: pointer;
  display: block;
  width: 100%;
}
.pointer-events-none {
  pointer-events: none !important; /* タップ操作を完全に無視させる */
}

._v-digital-time-picker {
  &__select {
    height: auto;
    min-width: 80px;
  }
  &__comma {
    font-size: $font-size;
  }
}

:deep(.v-overlay__content) {
  min-width: unset !important;
  max-width: 300px;
}

._v-digital-time-picker__select :deep(.v-select__selections) {
  width: 100px;
  font-size: $font-size;
  line-height: $font-size;
  justify-content: center;
}
</style>